import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { LocationData, LocationOptions, LocationPickerComponent } from '../../shared/location-picker/location-picker.component';
import { MainService } from '../../services/optimizer-service/optimizer.service';
import { AuthService } from '../../services/auth-service/auth.service';
import { Area } from '../../DataStructures/Area/Area';
import { Http, Headers } from '@angular/http';
import { ApplicationUrlSettings } from '../../settings/ApplicationUrlSettings';

@Component({
  selector: 'app-add-passenger',
  templateUrl: './add-passenger.component.html',
  styleUrls: ['./add-passenger.component.css']
})
export class AddPassengerComponent implements OnInit, AfterViewInit {

  @ViewChild('picker') picker: LocationPickerComponent;
  options: LocationOptions = {
    multipleLocations: false,
    searchBoxText: 'Enter an address....'
  };
  label = null;
  phone = null;
  fee: number = null;
  collection = null;
  comments = null;
  tripid;
  selectedAddress = null;
  addressRequired;
  locationInfo;
  addresses = [];
  adminPayload: any = {}
  customer = null;
  edit = false;
  deliveryFeeEnabled = false;
  disableDeliveryFeeCalculation = false;
  payload: {
    name: string,
    phone: string,
    comments: string,
    fee: number,
    collection: number,
    locationdata: LocationData
  } = null;

  // Autocomplete properties
  filteredUsers = [];
  showAutocomplete = false;
  selectedUser = null;
  tripCompanyId = null;
  selectedUserId = null;
  selectedEmployeeId = null;
  isSearching = false;

  constructor(public dialogRef: MatDialogRef<AddPassengerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private main: MainService, private auth: AuthService, private http: Http) {
    this.tripid = data.tripid;
    this.adminPayload = this.auth.getAdminPayload();
    this.addressRequired = this.adminPayload.type == 'BEARER' ? true : false;
    if (data.edit) {
      this.edit = data.edit;
      this.payload = data.payload;
      var area: Area = data.area;
      this.label = this.payload.name;
      this.fee = this.payload.fee;
      this.collection = this.payload.collection;
      this.comments = this.payload.comments;
      this.phone = this.payload.phone;
    }
    this.addresses = data.meta && data.meta.addresses ? data.meta.addresses : [];
    this.customer = data.meta && data.meta.customer ? data.meta.customer : null;
    this.deliveryFeeEnabled = !!(data.meta && data.meta.deliveryFeeEnabled);
    this.disableDeliveryFeeCalculation = !!(data.meta && data.meta.disableDeliveryFeeCalculation);

  }

  get canEditDeliveryFee(): boolean {
    if (this.adminPayload.type !== 'BEARER') {
      return true;
    }
    if (!this.deliveryFeeEnabled) {
      return true;
    }
    return this.disableDeliveryFeeCalculation;
  }
  ngAfterViewInit(): void {
    if (this.edit) {
      // Defer to next tick to avoid ExpressionChangedAfterItHasBeenCheckedError
      // (setAddress emits locationSelected which updates locationInfo during change detection)
      setTimeout(() => {
        this.picker.setAddress({
          address: this.payload.locationdata.address,
          lat: this.payload.locationdata.lat,
          lng: this.payload.locationdata.lng
        });
      }, 0);
    }
    
    // Get trip company ID for autocomplete
    if (this.adminPayload.type === 'PROVIDER' && this.tripid) {
      this.getTripCompanyId();
    }
  }

  ngOnInit() {
  }

  async getTripCompanyId() {
    try {
      const tripData = await this.main.getTrip(this.tripid);
      const parsedData = typeof tripData === 'string' ? JSON.parse(tripData) : tripData;
      if (parsedData && parsedData.data) {
        this.tripCompanyId = parsedData.data.companyid;
      }
    } catch (error) {
      console.error('Error getting trip company ID:', error);
    }
  }

  async searchUsers(searchTerm: string) {
    if (!searchTerm || searchTerm.length < 2 || !this.tripCompanyId) {
      this.filteredUsers = [];
      this.showAutocomplete = false;
      this.isSearching = false;
      return;
    }

    this.isSearching = true;
    this.showAutocomplete = true;

    try {
      const headers = new Headers({
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      });
      const url = `${ApplicationUrlSettings.NODE_API_URL}users/search?search=${encodeURIComponent(searchTerm)}&companyid=${this.tripCompanyId}`;
      const response = await this.http.get(url, { headers }).toPromise();
      const result = response.json();
      
      if (result.status) {
        this.filteredUsers = result.data;
        this.showAutocomplete = this.filteredUsers.length > 0;
      }
    } catch (error) {
      console.error('Error searching users:', error);
      this.filteredUsers = [];
      this.showAutocomplete = false;
    } finally {
      this.isSearching = false;
    }
  }

  onLabelInput(event: any) {
    const searchTerm = event.target.value;
    this.label = searchTerm;
    
    // Clear selected user if user starts typing manually
    if (this.selectedUser && searchTerm !== `${this.selectedUser.firstname} ${this.selectedUser.lastname}`) {
      this.clearSelectedUser();
    }
    
    if (this.adminPayload.type === 'PROVIDER') {
      this.searchUsers(searchTerm);
    }
  }

  selectUser(user: any) {
    this.selectedUser = user;
    this.label = `${user.firstname} ${user.lastname}`;
    this.phone = user.phone || '';
    this.selectedUserId = user.userid;
    this.selectedEmployeeId = user.employeeid;
    
    // Set address information if available
    if (user.address && user.lat && user.lng) {
      this.locationInfo = {
        address: user.address,
        lat: user.lat,
        lng: user.lng
      };
      // Update the location picker with the user's address
      this.picker.setAddress(this.locationInfo);
    }
    
    this.showAutocomplete = false;
    this.filteredUsers = [];
  }

  clearSelectedUser() {
    this.selectedUser = null;
    this.selectedUserId = null;
    this.selectedEmployeeId = null;
    // Don't clear the label, phone, or location as user might want to keep them
  }

  onLabelFocus() {
    if (this.adminPayload.type === 'PROVIDER' && this.label && this.label.length >= 2) {
      this.showAutocomplete = this.filteredUsers.length > 0 || this.isSearching;
    }
  }

  onLabelBlur() {
    // Delay hiding autocomplete to allow for clicks
    setTimeout(() => {
      this.showAutocomplete = false;
    }, 200);
  }

  setAddress() {
    var address = this.addresses.find(x => x.id == this.selectedAddress);
    this.label = this.customer.name;
    this.phone = this.customer.phone;
    this.locationInfo = address;
    this.picker.setAddress(this.locationInfo);
  }

  getJobTypeText() {
    return this.main.getJobTypeText();
  }

  isSaveDisabled() { }

  isPhoneInvalid(form: NgForm): boolean {
    const c = form && form.form && form.form.get('phone');
    return !!(c && c.touched && c.hasError('invalidPhone'));
  }

  isDisabled() {
    if (this.addressRequired) {
      if (this.label == null || this.label == '' || this.locationInfo == null) {
        return true;
      }
    } else {
      if (this.label == null || this.label == '') {
        return true;
      }
    }
    return false;
  }

  add(passengerForm?: NgForm) {
    if (passengerForm) {
      const phoneControl = passengerForm.form.get('phone');
      if (phoneControl && phoneControl.value && phoneControl.invalid) {
        phoneControl.markAsTouched();
        return;
      }
    }
    if (!this.tripid) {
      this.dialogRef.close({
        label: this.label,
        name: this.label,
        phone: this.phone,
        comments: this.comments,
        fee: this.fee,
        collection: this.collection,
        location: this.locationInfo,
        locationdata: this.locationInfo,
        userid: this.selectedUserId,
        employeeid: this.selectedEmployeeId
      });
    } else {
      var body = {
        label: this.label,
        name: this.label,
        phone: this.phone,
        comments: this.comments,
        fee: this.fee,
        collection: this.collection,
        location: this.locationInfo,
        locationdata: this.locationInfo,
        userid: this.selectedUserId,
        employeeid: this.selectedEmployeeId
      }
      if (this.edit) {
        this.dialogRef.close(body);
      } else {
        this.main.addPlaceholder(this.tripid, body).then(() => {
          this.dialogRef.close(body);
        }).catch(e => {
          this.dialogRef.close(null);
        })
      }
    }
  }

  close() {
    this.dialogRef.close();
  }

  locationSelected(locationData) {
    this.locationInfo = locationData[0];
  }

}
